var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content payment",attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_vm._m(0),_c('order-product',{attrs:{"produc-list":_vm.producList,"total-cost":_vm.totalCost}}),_c('order-form',{attrs:{"order-info":_vm.orderInfo,"total-cost":_vm.totalCost}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('h2',{staticClass:"tit"},[_vm._v("구매하기")])])
}]

export { render, staticRenderFns }